<template>
  <div class="content" style="width:1000px">
    <aside class="aside">
      <strong>{{ $t('app.packageRenewal.notes.title') }}</strong>
      <br />{{ $t('app.packageRenewal.notes.item1') }}
      <br />{{ $t('app.packageRenewal.notes.item2') }}
      <br />{{ $t('app.packageRenewal.notes.item3') }}
    </aside>
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="200px" >
      <el-form-item :label="$t('app.packageRenewal.tariffPackage')" prop="productId">
        <div class="select-button-container">
          <el-select v-model="propsParams.productId" filterable clearable :placeholder="$t('app.packageRenewal.selectTariffPlaceholder')"  style="width:100%" >
            <el-option v-for="item in optPackage" :key="item.id" :label="labelProductName(item)" :value="item.id" @click.native="selectPackage(item)"></el-option>
          </el-select>
          <!-- <el-button v-if="showInternation && adminShow" @click="showMoreCountry" style="margin-left: 10px;">查看区域</el-button> -->
        </div>
      </el-form-item>
      <!-- 此处限制  是限制在卡套餐上 -->
      <el-form-item v-if="showInternation && adminShow" :label="$t('app.packageRenewal.restrictedCountries')" prop="country">
        <el-button @click="showCountryDialog = true">{{ $t('app.packageRenewal.selectCountry') }}</el-button>
        <div class="region-list-scroll">
          <div class="region-list">
            <el-tag v-for="region in selectedCountries" :key="region.id" size="small">{{ region.name }}</el-tag>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="!showInternation && adminShow" :label="$t('app.packageRenewal.packagePrice')">
        <el-input v-model="selectProductPrice.operationPrice" :disabled="true" style="width:100%"></el-input>
      </el-form-item>

      <el-form-item :label="$t('app.packageRenewal.effectiveTime')" prop="activationTime">
        <el-select v-model="propsParams.activationTime" filterable clearable :placeholder="$t('app.packageRenewal.selectActivationTime')">
          <el-option v-for="item in timeSet" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-date-picker v-if="propsParams.activationTime == '10'"
          v-model="propsParams.activeDateTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('app.packageRenewal.selectDateTime')">
        </el-date-picker>
      </el-form-item>

      <el-form-item :label="$t('app.packageRenewal.autoRenew')" prop="autoCharge" :required="true" v-if="adminShow">
        <el-switch
          v-model="propsParams.autoCharge"
          active-value="1"
          inactive-value="0"
          :active-text="$t('app.common.yes')"
          :inactive-text="$t('app.common.no')"
          active-color="#13ce66"
          inactive-color="#C0CCDA">
        </el-switch>
      </el-form-item>
      <el-form-item v-if="propsParams.autoCharge == '1'" label-width="120px">
        <el-form-item label="选择套餐：" prop="autoProductId"  :required="true" v-if="adminShow && propsParams.autoCharge == '1'"  label-width="120px">
          <el-select
            v-model="propsParams.autoProductId"
            default-first-option
            filterable
            placeholder="请选择资费套餐"
            style="width:100%"
          >
            <el-option
              v-for="item in optPackage"
              :key="item.id"
              :label="labelProductName(item)"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        
      </el-form-item>

      <el-form-item :label="$t('app.packageRenewal.uploadMode')" prop="fieldType" >
        <el-radio-group v-model="propsParams.fieldType" @input="switchFieldType">
          <el-radio  label="1" >{{ $t('app.packageRenewal.batchIccids') }}</el-radio>
          <el-radio  label="2" >{{ $t('app.packageRenewal.iccidsRange') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('app.packageRenewal.iccidList')" prop="iccids" v-if="propsParams.fieldType == '1'">
        <el-input
          type="textarea"
          v-model="propsParams.iccids"
          rows="6"
          style="width:100%"
          @input="handleCardSum"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('app.packageRenewal.iccidRange')" prop="iccidRange" v-if="propsParams.fieldType == '2'">
        <el-row>
          <el-col :span="11">
            <el-input 
              v-model="propsParams.startIccid" 
              :placeholder="$t('app.packageRenewal.includeStartValue')" 
              clearable
              @paste.native="handlePaste"
            ></el-input>
          </el-col>
          <el-col :span="1" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-input 
              v-model="propsParams.endIccid" 
              :placeholder="$t('app.packageRenewal.includeEndValue')" 
              clearable
              @paste.native="handlePaste"
            ></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item v-if="number>0">
        <span style="top: -2px;color: #666;">{{ $t('app.packageRenewal.selectedCount') }}<em style="color:red">{{number}}</em>{{ $t('app.packageRenewal.items') }}</span>
      </el-form-item>
      <el-form-item :label="$t('app.packageRenewal.orderAmount')" prop="totalPrice" v-if="!nextShow">
        <el-row>
          <el-col :span="6" v-if="userProductData.data.yd">
            <div>
              <el-statistic :title="$t('app.packageRenewal.carrier.mobile')">
                <template slot="formatter"> {{userProductData.data.yd.totalCard}}/{{userProductData.data.yd.totalMoney}}{{ $t('app.common.currency') }} </template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6" v-if="userProductData.data.dx">
            <div>
              <el-statistic :title="$t('app.packageRenewal.carrier.telecom')">
                <template slot="formatter"> {{userProductData.data.dx.totalCard}}/{{userProductData.data.dx.totalMoney}}{{ $t('app.common.currency') }}</template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6" v-if="userProductData.data.lt">
            <div>
              <el-statistic :title="$t('app.packageRenewal.carrier.unicom')">
                <template slot="formatter"> {{userProductData.data.lt.totalCard}}/{{userProductData.data.lt.totalMoney}}{{ $t('app.common.currency') }} </template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6" v-if="userProductData.data.gj">
            <div>
              <el-statistic :title="$t('app.packageRenewal.carrier.international')">
                <template slot="formatter"> {{userProductData.data.gj.totalCard}}/{{userProductData.data.gj.totalMoney}}{{ $t('app.common.currency') }} </template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic :title="$t('app.packageRenewal.total')">
                <template slot="formatter"> {{userProductData.totalCard}}/{{userProductData.totalPrice}}{{ $t('app.common.currency') }} </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('app.packageRenewal.accountBalance')" prop="availAmount" v-if="!adminShow && !freeAgentShow">
        <el-input v-model="availAmount" :disabled="true" style="width:100%"></el-input>
      </el-form-item>

      <el-form-item :label="$t('app.packageRenewal.paymentMethod')" prop="payType" v-if="!adminShow && !freeAgentShow">
        <ul class="payClass">
          <li v-for="(item,index) in payList" :key="index" :class="{cur:payIndex === index}" @click="curButton(item,index)"> {{item}}</li>
        </ul>
      </el-form-item>

      <el-form-item :label="$t('app.packageRenewal.password')" prop="password"  :rules="this.payTypeShow ? ruleValidate.password : [{required : false}]" v-if="payTypeShow">
        <el-input v-model="propsParams.password" style="width:100%" :placeholder="$t('app.packageRenewal.enterRechargePassword')" type="password"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" v-if="nextShow" @click="nextSubmit()">{{ $t('app.common.nextStep') }}</el-button>
        <el-button type="success" v-if="!nextShow" @click="handleSubmit()">{{ $t('app.common.payNow') }}</el-button>
      </el-form-item>
    </el-form>
   
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" 
      @close="dialogClose" 
      :lock-scroll="false" 
      width="500px"
      v-dialogDrag 
      center
      :close-on-click-modal="false">
        <p style="text-align: center;font-size: 18px;">{{ $t('app.packageRenewal.totalAmount',{money:resultObj.totalMoney}) }}</p>
        <div :append-to-body="false" id="qrcodeDom" ></div>
    </el-dialog>
    <!-- 展示更多国家列表 -->
    <el-dialog title="区域列表" :visible.sync="moreCountryOpen" width="600px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
       <div class="tag-container">
        <el-tag
          v-for="item in filteredTableData"
          :key="item.name"
          type="success"
          class="custom-tag"
        >
          {{ item.name }}
        </el-tag>
      </div>
    </el-dialog>
    <!-- 国家选取弹窗 -->
    <country-select-dialog
      ref="countrySelectDialog"
      :visible.sync="showCountryDialog"
      title="请选择目标国家"
      :default-selected="selectedCountries"
      @confirm="handleCountryConfirm"
      @cancel="handleCountryCancel"
    ></country-select-dialog>
  </div>
</template>
<script>
import CountrySelectDialog from "@/components/dialogComponent/CountrySelectDialog.vue";
import { productList } from "@/api/api.js"; //不分页套餐列表
import { userInfo } from "@/api/api.js";//获取个人中心的信息 
import { userRechargeProductInfo , userSelectProductPrice , selectInternationalGroup} from "@/api/api.js";//获取个人中心的信息 

import { orderRechargePayment } from "@/api/api.js";//计算价格
import { orderQueryRecharge } from "@/api/api.js";//查看订单是否支付
import QRCode from 'qrcodejs2'
export default {
  name:"packageRenewal",
  components: {
    CountrySelectDialog
  },
  data() {
    return {
      showCountryDialog: false,
      selectedCountries: [],
      propsParams: {
        productId:undefined,
        operatorId:undefined,
        internationalSourceId:undefined,
        activationTime:0,
        fieldType:"1",
        iccids:"",
        cardActive:false,
        payType:0,
        autoCharge:"0",
        autoProductId:undefined,
        autoCount:'1',
        startIccid:"",
        endIccid:""
      },

      levelCard:false,
      packagePrice:"",
      availAmount:"",
      totalPrice:0,
      showInternation:false,
      operatorList:[],
      selectProductPrice:{},
      userProductData:{
        data:{
          dx:{totalCard:0,totalMoney:0},
          yd:{totalCard:0,totalMoney:0},
          lt:{totalCard:0,totalMoney:0},
        },
      },
      nextShow:true,
      ruleValidate: {
        productId: [
          { required: true, message: this.$t('app.packageRenewal.validate.tariffRequired'), trigger: "blur" }
        ],
        password: [
          { required: true, message: this.$t('app.packageRenewal.validate.enterPassword'), trigger: "blur" }
        ],
        iccids:[
          { required: true, message: this.$t('app.packageRenewal.validate.enterIccid'), trigger: "blur" }
        ],
        countryId:[
          { required: true, message: "请选择国家货币", trigger: "blur" }
        ],
        internationalSourceKey:[
          { required: true, message: "请选择国际资源", trigger: "blur" }
        ],
        iccidRange:[
           { validator: this.validateIccidRange, trigger: ['blur', 'change'] }
        ],
        autoProductId: [
          { required: true, message: "请输入资费套餐", trigger: "blur" }
        ],
      },
      timeSet:[
        {
          value: 0,
          label: this.$t('app.packageRenewal.effectTime.immediate')
        }, {
          value: 1,
          label: this.$t('app.packageRenewal.effectTime.nextMonth')
        },{
          value: 4,
          label: this.$t('app.packageRenewal.effectTime.expiry')
        }
      ],
      activationDay:1,
      optPackage:[],
      number:0,
      payList:[this.$t('app.packageRenewal.payment.balance'),this.$t('app.packageRenewal.payment.wechat'),this.$t('app.packageRenewal.payment.alipay')],
      payIndex:0,
      payTypeShow:true,
      // 弹窗部分
      dialogVisible:false,
      dialogTitle:this.$t('app.packageRenewal.confirmPayment'),
      resultObj:{},
      timer:null,
      productData:[],
      internationalSourceData:[],
      countryData:[],
      moreCountryOpen:false,
      searchQuery:'',
      moreCountryData:[]
    };
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
    freeAgentShow(){
      return this.$store.getters.user.userId =='1392379806515073024';
    },
    cardIccids(){
      return this.$store.state.card.productIccids;
    },
    filteredTableData() {
      return this.countryData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    }
  },
  methods: {
    handleCountryConfirm(selected) {
      this.selectedCountries = selected;
    },
    handleCountryCancel() {
    },
    // 资费套餐下拉
    queryServerList() {
      productList().then(res => {
        this.optPackage = res.data.data;
      });
    },
    // 初始化信息
    initData() {
      let params = {
				userId: localStorage.getItem("userId")
			};
      userInfo(params).then(res => {
        this.availAmount = res.data.data.availAmount;
      })
    },
    selectPackage(item){
      if(!item.id){
        return;
      }
      this.countryData = []
      this.showInternation = false;
      this.nextShow = true;
      if(item.type == '3'){
        this.showInternation = true;
        //国际
        this.selectInternationalCountryGroup(item.id);
      }else{
        //非国际套餐
        this.handleSelectProduct(item.id)
      }
      this.propsParams.autoProductId = item.id
    },
    //国内展示价格
    handleSelectProduct(productId){
      userSelectProductPrice({productId}).then(res=>{
        this.selectProductPrice = res.data.data
      })
    },
    //查询套餐可以用国家列表 作废
    selectInternationalCountryGroup(productId){
      selectInternationalGroup({productId}).then(res=>{
        this.countryData = res.data.data
      })
    },
    commonPackage(productId){
      this.showInternation = false;
      let { iccids } = this.propsParams;
      let params = {
        productId:productId,
        iccids:iccids ? iccids.split("\n") : [],
      }
      userRechargeProductInfo(params).then(res=>{
        this.userProductData = res.data.data;
      })
    },
    labelProductName(item){
      if(item.channel == 'multi'){
        return item.id + '-【国际】【RX国际】' + item.productName;
      }
      if(item.channel == 'cmlink'){
        return item.id + '-【国际】【ZY国际】' + item.productName;
      }
      if(item.channel == 'cmBrazil'){
        return item.id + '-【国际】【BX国际】' + item.productName;
      }
      if(item.channel == 'Quadcell'){
        return item.id + '-【国际】【QC国际】' + item.productName;
      }
      return item.id + '-' + item.productName;
    },
    
    handleCardSum(){
      this.nextShow = true
      let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n"):[];
      this.number = iccids.filter(item=>!!item).length
      if(this.number == 0){
        this.$store.dispatch('ClearProductIccids')
      }else{
        this.$store.dispatch('CacheProductIccids', iccids.filter(item=>!!item).join(","))
      }
    },
    switchFieldType(label){
      this.nextShow = true
      if(label == '2'){
        this.number = 0
      }
      if(label == '1'){
        let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n"):[];
        this.number = iccids.filter(item=>!!item).length
      }

    },
    nextSubmit(){
      this.$refs['propsParams'].validate((valid) => {
        if(valid){
          let { iccids } = this.propsParams;
          let params = {
            ...this.propsParams,
            iccids:iccids ? iccids.split("\n") : [],
          };
          userRechargeProductInfo(params).then(res=>{
            this.nextShow = false
            this.number = res.data.data.totalCard
            if(this.number == 0){
              this.nextShow = true
              this.$message.warning('输入的卡号都不存在，请重新输入！');
            }
            this.userProductData = res.data.data;
          })
        }
      })
    },
    handleSubmit() {
      this.$refs['propsParams'].validate((valid) => {
        if(valid){
          let countryCodes = this.selectedCountries && this.selectedCountries.map(item=>item.countryCode)
          let { cardActive } = this.propsParams;
          let { iccids } = this.propsParams;
          let params = {
            ...this.propsParams,
            iccids:iccids ? iccids.split("\n") : [],
            cardActive:cardActive == true ? 1:0,
            countryCodes:countryCodes
          };
          //管理员支付或者免费用户支付  弹出确认按钮
          if(this.adminShow || this.freeAgentShow){
            this.submitFreePay(params);  
          }else{
            this.submitUserPay(params);
          }
          
        }
      })
    },
    submitFreePay(params){
      this.$alert("此次充值支付金额总计：0 元", '温馨提示', { confirmButtonText: '确定',})
      .then(() => {
        orderRechargePayment(params).then(res=>{
          if (res.data.code == 200) {
              this.$notify.info({
                title: "提示",
                message: "已提交充值，请在订单页面查看内容",
                duration: 1000,
                offset:30
              });
              this.resetSubmitForm()
              this.countryData = []
              setTimeout(()=>{
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          }else{
              this.$message.error(res.data.message);
          }
        })
      })
      .catch(() => {
        this.$message.warning('取消充值');
      })
    },
    submitUserPay(params){
      if(params.payType == '0'){
          let money = this.userProductData.totalPrice
          this.$alert( this.$t('app.packageRenewal.alert.renewTotal', { money }), this.$t('app.common.reminder'), { confirmButtonText: this.$t('app.common.confirm'),})
          .then(() => {
            orderRechargePayment(params).then(res=>{
              if (res.data.code == 200) {
                  this.$notify.info({
                    title: this.$t('app.common.tip'),
                    message: this.$t('app.packageRenewal.notify.balancePaymentCompleted'),
                    duration: 1000,
                    offset:30
                  });
                  this.resetSubmitForm()
                  this.countryData = []
                  setTimeout(()=>{
                    this.$router.push({ path: `/taskCenter/missionList`});
                  },1000)
              }else if(res.data.code == 414){
                this.$message.warning(this.$t('app.packageRenewal.notify.insufficientBalance'));
              }else{
                this.$message.error(res.data.message);
              }
            })
          })
          .catch(() => {
            this.$message.warning(this.$t('app.packageRenewal.notify.cancelRecharge'));
          })
      }else{
        orderRechargePayment(params).then(res=>{
          if (res.data.code == 200) {
              this.resultObj = res.data.data;
              this.dialogVisible = true;
              this.$nextTick(()=>{
                document.getElementById("qrcodeDom").innerHTML=''; //先清空之前生成的二维码
                new QRCode('qrcodeDom',{
                  width: 344,
                  height:344,
                  text: res.data.data.result,  //需要转换的链接
                  render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                  background: '#f0f',   // 背景色
                  foreground: '#ff0'    // 前景色
                });
                this.isOrderPay()
              })
          }else if(res.data.code == 414){
            this.$message.warning('余额不足，请更换支付方式');
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    resetSubmitForm(){
      this.resetForm("propsParams");
      this.initData()
      this.propsParams.iccids = ""
      this.propsParams.startIccid = ""
      this.propsParams.endIccid = ""
      this.$store.dispatch('ClearProductIccids')
      this.nextShow = true
      this.number = 0
      //清空页面数据
      this.userProductData = {
        data:{
          dx:{totalCard:0,totalMoney:0},
          yd:{totalCard:0,totalMoney:0},
          lt:{totalCard:0,totalMoney:0},
        },
      }
      this.selectedCountries = []
      this.selectProductPrice = {}
       if (this.$refs.countrySelectDialog) {
        this.$refs.countrySelectDialog.resetAll();
      }
    },
    isOrderPay(){
      this.timer = setInterval(() => {
        orderQueryRecharge({orderNum:this.resultObj.orderNum}).then(res =>{
          if(res.data.data == '3'){
            this.$notify.info({
              title: "提示",
              message: "已提交余额充值，请在订单页面查看内容",
              duration: 1000,
              offset:30
            });
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$store.dispatch('ClearProductIccids')
            clearInterval(this.timer);
            this.timer = null;
            this.$router.push({ path: `/taskCenter/missionList`});
          }
        })
      },2000)
    },
    open(){
      this.$alert('账户余额不足，请前往【账户中心】充值。', '温馨提示', {
          confirmButtonText: '去充值',
      }).then(() => {
        this.$router.push('/users/onlinepay')
      })
    },
    curButton(item,index){
      this.payIndex = index;
      this.propsParams.payType = index;
      this.payTypeShow = index == 0 ? true:false;
    },
    dialogClose(){
      clearInterval(this.timer);
      this.timer = null;
    },
    validateIccidRange(rule, value, callback) {
      if (!this.propsParams.startIccid) {
        callback(new Error(this.$t('app.packageRenewal.validate.startRangeRequired')));
      } else if (!this.propsParams.endIccid) {
        callback(new Error(this.$t('app.packageRenewal.validate.endRangeRequired')));
      }else {
        callback();
      }
    },
    handlePaste(event){
      event.stopPropagation();
    },
    showMoreCountry(){
      this.moreCountryOpen = true
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'packageRenewal' || to.name == 'batchRecharge'){
          this.queryServerList();
          if(!!this.cardIccids){
            this.propsParams.iccids = this.cardIccids.replace(/,/g, "\n");
            this.number = this.propsParams.iccids.split("\n").length;
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.queryServerList();
    this.initData()
    if(!!this.cardIccids){
      this.propsParams.iccids = this.cardIccids.replace(/,/g, "\n");
      this.number = this.propsParams.iccids.split("\n").length;
    }
    if(this.adminShow){
      this.timeSet = [
        {
          value: 0,
          label: this.$t('app.packageRenewal.effectTime.immediate')
        }, {
          value: 1,
          label: this.$t('app.packageRenewal.effectTime.oneMonth')
        }, {
          value: 2,
          label: this.$t('app.packageRenewal.effectTime.threeMonths')
        }, {
          value: 3,
          label: this.$t('app.packageRenewal.effectTime.sixMonths') 
        },{
          value: 4,
          label: this.$t('app.packageRenewal.effectTime.expiry')
        },{
          value: 5,
          label: this.$t('app.packageRenewal.effectTime.cardHalt')
        },{
          value: 10,
          label: this.$t('app.packageRenewal.effectTime.customTime')
        }
      ];
      this.levelCard = true
    }
  }
};
</script>
<style scoped lang="less">
.select-button-container {
  display: flex;
  align-items: center;
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; 
  padding-top: 10px; 
  .custom-tag {
    margin: 0; 
  }
}
  .aside {
    background: #eef1f6;
    padding: 20px 30px;
    margin-bottom: 20px;
    border-radius: 2px;
    display: block;
    line-height: 32px;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    color: #2c3e50;
    -webkit-font-smoothing: antialiased;
    margin-left: 25px;
    width: 100%;
  }
  /deep/ .el-textarea.is-disabled .el-textarea__inner{
    color: #1E1E1E !important;
  }
  /deep/ .el-input.is-disabled .el-input__inner{
    color: #1E1E1E !important;
  }
  .sm-class{
    margin-left: 130px;
    margin-top: 50px;
  }
  .payClass{
    display: flex;
    li{
      margin-right: 20px;
      width: 125px;
      text-align: center;
      border: 1px solid #C0C4CC;;
    }
  }
  .cur{
    border: 1px solid #32c169 !important;
    background-image:url(../../assets/img/wx_payImg2.png);
    background-repeat: no-repeat;
    background-position:13px 15px;
    background-size:110px;
  }

  #qrcodeDom{
    width:344px;
    height:344px;
    margin:0 auto;
  }

  @media screen and (max-width: 750px){
    /deep/ .el-form-item__label{
      width: 75px!important;
    }
   /deep/ .el-form-item__content{
     margin-left: 120px!important;
   }
  }

  .el-input-number-day {
      position: relative;
  }
  .el-input-number-day::after {
      content: '天';
      display: inline-block;
      height: 20px;
      line-height: 20px;
      width: 20px;
      text-align: center;
      position: absolute;
      right: 38px;
      top: 50%;
      transform: translateY(-50%);
  }
  .el-input-number-day .el-input__inner{
      padding-left: 30px;
      padding-right: 48px;
  }

  .region-list-scroll {
     max-height: 200px; 
    /* 超出部分可滚动 */
    overflow-y: auto;
  }

  /* 滚动条整体样式 */
  .region-list-scroll::-webkit-scrollbar {
    width: 8px; /* 垂直滚动条宽度 */
    height: 8px; /* 水平滚动条高度 */
  }

  /* 滚动条轨道 */
  .region-list-scroll::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 4px;
  }

  /* 滚动条滑块 */
  .region-list-scroll::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }

  /* 滚动条滑块悬停状态 */
  .region-list-scroll::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8;
  }

  /* Firefox 滚动条样式 */
  .region-list-scroll {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;
  }

  .region-list {
    display: flex;
    flex-wrap: wrap;
    row-gap: 5px;
    column-gap: 5px;
    padding: 5px 0;
  }


</style>

